import { Item } from '@radix-ui/react-toggle-group';
import type { ComponentProps } from 'react';

type Props = ComponentProps<typeof Item>;

export const FilterToggle = ({ ...props }: Props) => (
  <Item
    className="h-10 w-full rounded-full bg-white shadow-[0px_0px_4px_rgba(212,215,213,1)] hover:bg-action-primary hover:text-white radix-disabled:!bg-white radix-disabled:text-content-subtle radix-disabled:shadow-none radix-state-on:bg-action-primary radix-state-on:text-white"
    {...props}
  />
);
